export interface FAQItem {
  id: string;
  question: string;
  answer: string;
}

export const faqItems: FAQItem[] = [
  {
    id: "faq-1",
    question: "91社区是什么？",
    answer: "91社区是国内领先的综合性内容平台，汇聚了科技数码、生活娱乐、学习教育、游戏动漫、影视音乐、健康养生等六大领域的优质内容。我们致力于为每一位用户提供流畅的浏览体验和多元化的内容选择，满足不同用户的个性化需求。",
  },
  {
    id: "faq-2",
    question: "91社区的内容是如何产生的？",
    answer: "91社区的内容来自两个渠道：一是我们自有的专业内容团队，他们深耕各自领域，确保内容的专业性和深度；二是社区的优质创作者，他们持续产出高质量的原创内容，涵盖各个热门话题和细分领域。所有内容在上线前都经过严格的审核和质量把控。",
  },
  {
    id: "faq-3",
    question: "如何成为91社区的会员？",
    answer: "您可以通过点击网站右上角的「注册」按钮，使用手机号或邮箱完成快速注册。注册后即可免费浏览平台上的大部分内容。我们还提供高级会员服务，会员可以享受无广告浏览、独家深度内容、优先体验新功能等特权。",
  },
  {
    id: "faq-4",
    question: "91社区是否有手机版？",
    answer: "是的！91社区提供完善的移动端体验。您可以通过手机浏览器直接访问我们的网站，享受与桌面端同样流畅的浏览体验。同时，我们的iOS和Android客户端也在各大应用商店上线，搜索「91社区」即可下载。移动端支持离线下载功能，方便您在没有网络的环境下阅读。",
  },
  {
    id: "faq-5",
    question: "如何在91社区投稿或成为创作者？",
    answer: "我们非常欢迎优质内容创作者加入91社区！在注册账号后，您可以在个人中心找到「创作者中心」入口，提交创作申请。我们的审核团队会在1-3个工作日内完成资质审核。审核通过后，您就可以在平台上发布原创内容，并获得相应的创作收益。",
  },
  {
    id: "faq-6",
    question: "91社区的内容更新频率如何？",
    answer: "91社区保持每日更新的节奏，每天有超过200篇优质新内容上线。我们的编辑团队7×24小时不间断工作，确保您总能在第一时间获取到最新、最热门的资讯和深度内容。热门分类的内容更新更为频繁，平均每天新增50篇以上。",
  },
  {
    id: "faq-7",
    question: "遇到内容加载缓慢或无法访问怎么办？",
    answer: "如果您遇到访问问题，建议先尝试以下步骤：1) 检查网络连接是否正常；2) 清除浏览器缓存和Cookie；3) 尝试使用其他浏览器访问。如果问题仍然存在，您可以联系我们的客服团队（邮箱：support@91shequ.com），我们会在第一时间为您排查和解决。",
  },
];